import axios from '@dap/shared-utils/http.js';

export default {
    getCustomList (params = {}) {
        return axios.get('/dapper/api/insights/my_insight/list/', { params });
    },

    getBookmarkList (params = {}) {
        return axios.get('/dapper/api/insights/my_insight/collect', { params });
    },

    updateCustomTable (params = {}, id = '') {
        if (id) {
            return axios.put(`/dapper/api/insights/my_insight/item/${id}`, params);
        }

        return axios.post('/dapper/api/insights/my_insight/list/', params);
    },

    updateCustomTable2 (data = {}, id = '') {
        if (id) {
            return axios.post(`/dapper/api/insights/my_insight_v2/item/${id}`, data);
        }

        return axios.post('/dapper/api/insights/my_insight_v2/item', data);
  },
    updateCustomTable3 (data = {}, id = '') {
        return axios.post(`/dapper/api/insights/my_insight_v2/item/${id}/partial`,data)
  },
    updateCollect (params = {}) {
        return axios.post('/dapper/api/insights/my_insight/collect', params);
    },

    getCustomConfig (id, params = {}) {
        return axios.get(`/dapper/api/insights/my_insight/item/${id}`, {
            params,
        });
    },

    getCustomConfig2 (id, params = {}) {
        return axios.get(`/dapper/api/insights/my_insight_v2/item/${id}`, {
            params,
        });
    },

    getTableList (type, params = {}) {
        return axios.post(`/dapper/api/insights/custom_insight/${type}`, params);
    },

    getTableFullList (type, params = {}) {
        return axios.get(`/dapper/api/insights/custom_insight/${type}_full`, {
            params,
        });
    },

    getBlockList (type, params = {}) {
        return axios.get(`/dapper/api/insights/custom_insight/${type}_block`, {
            params,
        });
    },

    getTotalInsCostNumber (params = {}) {
        return axios.get('/dapper/api/insights/custom_insight/total_ins_cost', {
            params,
        });
    },

    getRegionPackageList (params = {}) {
        return axios.get('/coach/api/region_packages', { params });
    },

    getRegionDict (params = {}) {
        return axios.get('/dapper/api/insights/my_insight/region_dict', {
            params,
        });
    },

    getCustomListNew (type, params) {
        // type = recent, mine, fav
        return axios.get(`/dapper/api/insights/my_insight_v2/${type}`, {
            params,
        });
    },

    getCustomFolderList (params) {
        return axios.get('/dapper/api/insights/my_insight_v2/folders', {
            params,
        });
    },

    getCustomListInFolder (id, params) {
        return axios.get(`/dapper/api/insights/my_insight_v2/folder/${id}/custom_insights_v2`, { params });
    },

    favCustom (id) {
        return axios.post(`/dapper/api/insights/my_insight_v2/fav/${id}`);
    },

    unFavCustom (id) {
        return axios.post(`/dapper/api/insights/my_insight_v2/unfav/${id}`);
    },

    deleteCustomTable (id) {
        return axios.delete(`/dapper/api/insights/my_insight_v2/item/${id}`);
    },

    moveToFolder (id, data) {
        return axios.post(`/dapper/api/insights/my_insight_v2/mv/item/${id}`, data);
    },

    getCreatorList (params = {}) {
        params.status = 1;
        return axios.get('/coach/api/dap_user_id', { params });
    },

    getAdPackages (params = {}) {
        return axios.get('/coach/api/ad_packages', { params });
    },
};
